import { render, staticRenderFns } from "./DCIRegisterInputForm.vue?vue&type=template&id=9b1d7c36&scoped=true"
import script from "./DCIRegisterInputForm.vue?vue&type=script&lang=js"
export * from "./DCIRegisterInputForm.vue?vue&type=script&lang=js"
import style0 from "./DCIRegisterInputForm.vue?vue&type=style&index=0&id=9b1d7c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1d7c36",
  null
  
)

export default component.exports